import {CHECK_PAYOUTS_FLAG} from '@sollapay/types';

export const FeatureFlag = {
  ACCOUNT_SETTINGS: 'account_settings',
  CHECK_PAYOUTS: CHECK_PAYOUTS_FLAG,
  FIRM_SETTINGS: 'firm_settings',
  PAYOUTS_TAB: 'payouts_tab'
} as const;

export type FeatureFlagKey = (typeof FeatureFlag)[keyof typeof FeatureFlag];
